import i from 'i18next'
import Head from 'next/head'
import { motion } from 'framer-motion'
import useTranslations, { getTranslations } from 'lib/hooks/use-translations'
import { getMenu, getMenuCollections } from 'lib/hooks/use-collections'
import Layout from 'components/Layout'
import Title from 'components/Title'
import Footer from 'components/sections/Footer'

export async function getStaticProps() {
	const translations = await getTranslations({ page: 'terms' })
	const nav = await getMenu()
	const collections = await getMenuCollections()
	return {
		props: { translations, nav, collections },
		revalidate: 21600,
	}
}

export default function Terms({ loaded, translations, nav, collections }) {
	useTranslations( translations )

	return (
		<Layout loaded={loaded} nav={nav} collections={collections}>
			<Title page="terms" />
			<Head>
				<meta name="robots" content="noindex" />
			</Head>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 1 }}
			>
				<section className="cf">
					<h1>{i.t( 'terms.title' )}</h1>
					{i.t( 'terms.text', { postProcess: 'markdown-jsx' })}
				</section>
			</motion.div>
			<Footer />
			<style jsx>{`
				h1 {
					margin-bottom: 2em;
				}
				@media ( min-width: 800px ) {
					section {
						padding-right: 40%;
					}
				}
				section {
					margin-top: 40px;
					word-break: break-word;
				}
				section :global( h2 ) {
					font-size: 23px;
					font-weight: 500;
					margin-bottom: 1em;
				}
				section :global( p ) {
					margin-top: 1em;
					white-space: pre-wrap;
				}
				section :global( p + h2 ) {
					margin-top: 2em;
				}
				section :global( em ) {
					font-style: normal;
					text-decoration: underline;
				}
			`}</style>
		</Layout>
	)
}
